<template>
  <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData" :isPrestazioni="true">
    <template slot="tab-content-event">
      <gastro-inserzione-videocapusla-view-component @update="onUpdateJsonData"></gastro-inserzione-videocapusla-view-component>
    </template>
  </eventi-view-component>
</template>

<script>
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import GastroInserzioneVideocapuslaViewComponent from "../components/GastroInserzioneVideocapuslaViewComponent.vue";
export default {
  components: { EventiViewComponent, GastroInserzioneVideocapuslaViewComponent },
  mixins: [UtilityMixin, EventiMixin],

  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  data() {
    return {
      // titoloEvento: this.getLabelTraduora("patients.gastroenterology.egds"),
      titoloEvento: "Inserzione Videocapsula",
      linkback: null,
      linkedit: null,
      jsonData: {},
      pathResourceFirma: "/gastroinserzionevideocapusla",
      pathResource: "/gastroinserzionevideocapusla",
      tabIndex: 0,
      id: null,
      pathRestValidation: "/validation",
      isThisFirmato: false,
      showModalLoading: false,
      linkPrintData: null,
    };
  },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    let me = this;
    me.jsonData.idPaziente = this.$route.query.idPaziente;
    me.id = this.$route.params.id;
  },

  methods: {
    updateStatoFirma(firmato) {
      console.log(firmato);
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
      console.log(me.jsonData);
      me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
    },
  },
};
</script>
